import api from "./api";

export const addApproval = async (extractionRight: any): Promise<any> => {
  const { data } = await api.post("/admin/approvals", {
    extractionRightId: extractionRight.id,
  });

  return data.approval;
};
